var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRideGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 44,
    width: 44,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "#009900"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C153.755,0,70.573,83.182,70.573,185.426c0,126.888,165.939,313.167,173.004,321.035 c6.636,7.391,18.222,7.378,24.846,0c7.065-7.868,173.004-194.147,173.004-321.035C441.425,83.182,358.244,0,256,0z M256,278.719 c-51.442,0-93.292-41.851-93.292-93.293S204.559,92.134,256,92.134s93.291,41.851,93.291,93.293S307.441,278.719,256,278.719z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 188,
    r: 128
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    transform: "matrix(0.45,0,0,0.45,135,90)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M331,0c-24.814,0-45,21.186-45,46c0,24.814,20.186,45,45,45c24.814,0,45-20.186,45-45C376,21.186,355.814,0,331,0z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M451,424.763V209.711l25.605-25.605c5.859-5.859,5.859-15.352,0-21.211c-5.859-5.859-15.352-5.859-21.211,0 l-18.322,18.322C436.699,181.189,436.381,181,436,181c-2.408,0-4.598,0.69-6.614,1.697C426.673,181.888,423.972,181,421,181 h-47.578l-51.211-51.211c-14.377-14.377-38.941-10.935-48.428,8.555l-59.619,120.238c-6.753,13.491-2.358,30,10.195,38.379 L301,348.055V422h-75c-24.814,0-45,20.186-45,45c0,24.814,20.186,45,45,45c24.814,0,45-20.186,45-45 c0-5.284-1.082-10.385-2.763-15.1h125.526c-1.681,4.715-2.763,9.816-2.763,15.1c0,24.814,20.186,45,45,45 c24.814,0,45-20.186,45-45C481,447.47,468.422,430.976,451,424.763z M226,482c-8.276,0-15-6.724-15-15s6.724-15,15-15 s15,6.724,15,15S234.276,482,226,482z M361,422v-90c0-10.049-4.995-19.38-13.359-24.961l-67.969-45.322l29.561-60.063 l30.557,30.557C345.458,237.88,352.987,241,361,241h17.333c-3.397,5.751-2.88,14.163,2.062,19.105 c2.93,2.93,6.768,4.395,10.605,4.395c3.837,0,7.676-1.465,10.605-4.395L419.711,241H421v181H361z M436,482 c-8.276,0-15-6.724-15-15s6.724-15,15-15s15,6.724,15,15S444.276,482,436,482z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M196,91H46c-8.291,0-15,6.709-15,15s6.709,15,15,15h150c8.291,0,15-6.709,15-15S204.291,91,196,91z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76,211H46c-8.291,0-15,6.709-15,15s6.709,15,15,15h30c8.291,0,15-6.709,15-15S84.291,211,76,211z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M136,151H46c-8.291,0-15,6.709-15,15s6.709,15,15,15h90c8.291,0,15-6.709,15-15S144.291,151,136,151z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M207.719,321.922c-6.879-4.59-12.404-10.466-16.708-17.032L162.455,362H91c-16.538,0-30,13.462-30,30 c0,16.538,13.462,30,30,30h90c11.44,0,21.724-6.357,26.836-16.582l31.278-62.565L207.719,321.922z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRideGreen);
export default __webpack_public_path__ + "static/media/ride-green.208301f703e82b95d5acdd9ee947a834.svg";
export { ForwardRef as ReactComponent };